export default function () {
  return {
    // SETTINGS
    customisation: {
      layout: 0, // homepage layouts
      theme: 0, // 0: darkmode; 1: lightmode
      menu: 0, // 0: standard; 1: compact
    },
    currentLayout1HomeTemplateId: null,
    connections: {},
    TVMode: false,
    betaFeatureAccess: false,

    // MIGRATIONS/HOOTMAIL
    updatesRequiredCount: null,

    // TENANT POSTS
    homePosts: [],

    // CLOUD
    currentCloudPost: {},
    savedCloudPosts: [],
    cloudTenantLeaders: {
      flagged_tenants: [],
      posts: [],
      shares: [],
      share_avg: [],
    },
    filterCloudBy: {
      keywords: null,
      category: null,
      year: null,
      tag: null,
      industry: null,
      region: null,
      saved: null,
      old_events: null,
      order_events_by_publish_date: null,
      org_posts_only: false,
    },

    // MAIL
    followers: [],
    followersBounced: [],
    followersListless: [],

    mailLists: [],
    mailListsHail: {},

    newsletterPosts: [],
    newsletterSelectedPosts: [],

    autoNewsletterStatus: null,

    schoolsList: [],
  }
}
